/* import __COLOCATED_TEMPLATE__ from './unprotected-attributes-warning.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntercomAttribute from 'embercom/models/attribute';
import type AppService from 'embercom/services/app-service';
import {
  SAFE_ATTRIBUTE_IDENTIFIERS,
  FIN_DATA_CONNECTOR_PATH,
} from 'embercom/models/workflow-connector/action';

interface Args {
  usedAttributeArray: string[];
  url?: string;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class UnprotectedAttributesWarning extends Component<Signature> {
  @service declare attributeService: any;
  @service declare appService: AppService;
  @service declare intl: any;

  get isProtectedAttributesOnlyEnabled(): boolean {
    return this.appService.app.canUseFeature('data-connector-protected-attributes-only');
  }

  get unprotectedAttributes() {
    let attributes = this.args.usedAttributeArray;
    return this.attributeService.attributes.filter((attr: IntercomAttribute) => {
      if (!attributes.includes(attr.identifier)) {
        return false;
      }
      if (attr.preventUpdateFromMessenger) {
        return false;
      }
      if (
        this.isProtectedAttributesOnlyEnabled &&
        SAFE_ATTRIBUTE_IDENTIFIERS.includes(attr.identifier)
      ) {
        return false;
      }
      return true;
    });
  }

  get shouldShowWarning() {
    return this.unprotectedAttributes.length > 0;
  }

  get targetsFinDataConnector(): boolean {
    return this.args.url?.includes(FIN_DATA_CONNECTOR_PATH) ?? false;
  }

  get isBlocking(): boolean {
    return (
      this.isProtectedAttributesOnlyEnabled &&
      this.targetsFinDataConnector &&
      this.unprotectedAttributes.length > 0
    );
  }

  get bannerType(): 'warning' | 'error' {
    return this.isBlocking ? 'error' : 'warning';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::Builder::Body::Sections::Request::UnprotectedAttributesWarning': typeof UnprotectedAttributesWarning;
    'workflow-connector/builder/body/sections/request/unprotected-attributes-warning': typeof UnprotectedAttributesWarning;
  }
}
